module.exports = __webpack_public_path__ + "media/images/spree/frontend/panels/cart/close-aa1b15a984e73311a393122087dcabbf.png";